import { createMuiTheme } from '@material-ui/core/styles';

export const anaTheme = createMuiTheme({
  palette: {
    text: {
      primary: '#0B308E',
      secondary: '#526391',
    },
    primary: {
      main: '#0B308E',
      dark: '#0B308E',
    },
    secondary: {
      main: '#0090e8',
      dark: '#0090e8',
    }
  },
  overrides: {
    MuiAppBar: {
      root: {
        borderBottom: '1px solid #CBD2E3',
      }
    },
    MuiButton: {
      root: {
        borderRadius: '2px',
      }
    },
    MuiInput: {
      input: {
        '&::placeholder': {
          color: '#526391',
          opacity: 0.8,
          fontSize: '11px',
        }
      },
      underline: {
        '&:before': {
          borderBottom: '1px solid #CBD2E3',
        }
      },
    },
    MuiInputLabel: {
      root: {
        color: '#526391',
      }
    },
    MuiOutlinedInput: {
      input: {
        '&::placeholder': {
          color: '#526391',
          opacity: 0.8,
          fontSize: "0.75rem",
        }
      },
      notchedOutline: {
        border: '1px solid #CBD2E3',
      },
    },
    MuiPaper: {
      elevation4: {
        boxShadow: undefined,
      }
    },
    MuiSelect: {
      icon: {
        color: '#0B308E',
      }
    },
  }
});
